export default "__VITE_ASSET__920ddf8f__"